import React, {Component} from "react";
import PublicCatalogLayout from "../../layouts/PublicCatalogLayout"
import EventSubheader from "../partials/EventSubheader"
import { isJaguar } from "@/utility/UserUtils";

export default class ReportsDashboard extends Component {

  render() {
    const {event} = this.props;
    return (
      <PublicCatalogLayout
        {...this.props}
        currentPage="events"

        groups={[]}
        subHeader={
          <EventSubheader 
            {...this.props}
            activeTab="reports"
          />
        }
      >
        <div className="events-header">Reports</div>
        <div className="reports-dashboard-option">
          <a href={`/events/${event.id}/reports/items`}>Item Reports</a>
        </div>
        {isJaguar(this.props.user) && (
          <div className="reports-dashboard-option">
            <a href={`/events/${event.id}/reports/losses`}>Loss Report</a>
          </div>
        )}
        <div className="reports-dashboard-option">
          <a href={`/events/${event.id}/reports/returned`}>Shipped vs. Returned Report</a>
        </div>
        {isJaguar(this.props.user) && (
          <div className="reports-dashboard-option">
            <a href={`/events/${event.id}/reports/events_rental_cost_report?clean=true&jaguar=true`}>Rental Cost Report</a>
          </div>
        )}
      </PublicCatalogLayout> 
    );
  }
}